import { useState } from 'react';
import { Menu, MenuItem } from '@mui/material';
import { MoreVert, Edit } from '@mui/icons-material';
import VerifiedIcon from '@mui/icons-material/Verified';

import VerifyBankModal from './VerifyBankModal';
import AddBankModal from './AddBankModal';

const BasicPopover = ({ id, isVerified, fetchPropertyTypeBankDetails }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [updateBankModal, setUpdateBankModal] = useState(false);
  const [menu, setMenu] = useState(null);
  const openMenu = ({ currentTarget }) => setMenu(currentTarget);
  const closeMenu = () => setMenu(null);
  // handler function
  const handleEdit = () => {
    closeMenu();
    setUpdateBankModal('Modal1');
  };
  const handleVerify = () => {
    closeMenu();
    setModalOpen(true);
  };
  return (
    <div>
      <MoreVert
        variant="contained"
        onClick={openMenu}
        style={{ cursor: 'pointer' }}
      />
      <Menu
        id="simple-menu"
        anchorEl={menu}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={Boolean(menu)}
        onClose={closeMenu}
      >
        {/* <MenuItem onClick={handleEdit}>
          <Edit style={{ marginRight: '4px' }} /> Edit Details
        </MenuItem> */}
        {!isVerified && (
          <MenuItem onClick={handleVerify}>
            <VerifiedIcon style={{ marginRight: '4px' }} />
            Verify Bank
          </MenuItem>
        )}
      </Menu>
      <VerifyBankModal
        id={id}
        fetchPropertyTypeBankDetails={fetchPropertyTypeBankDetails}
        setModalOpen={setModalOpen}
        modalOpen={modalOpen}
      />
      <AddBankModal
        typeBankId={id}
        fetchBankDetails={fetchPropertyTypeBankDetails}
        modalOpen={updateBankModal}
        setModalOpen={setUpdateBankModal}
        updateBankModal={true}
      />
    </div>
  );
};

export default BasicPopover;
